<i
  [ngbPopover]="popoverBody"
  [popoverTitle]="popoverTitle"
  [popoverClass]="'audit-popover'"
  class="info-icon"
  container="body"
>
</i>
<ng-template #popoverTitle>Audit Info</ng-template>
<ng-template #popoverBody>
  <table class="table table-sm table-borderless">
    <thead>
      <tr>
        <th>Modified By</th>
        <th>Modified Date</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ modifiedBy }}</td>
        <td>{{ modifiedDate | date: 'MM/dd/yyyy' }}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
